//= require bijou/cjs_shim
//= require bijou/base
//= require bijou/jquery-ui

require('../base')
require('../../../../../vendor/assets/javascripts/bijou/jquery-ui')

;(function ($) {
  'use strict'

  // Monkey patch datepicker widget to apply vertical offset to calendar

  var dpCheckOffset = $.datepicker._checkOffset
  $.extend($.datepicker, {
    _checkOffset: function (inst, offset, isFixed) {
      offset = dpCheckOffset.apply(this, arguments)
      offset.top += offset.top < inst.input.offset().top ? -5 : 5
      return offset
    }
  })

  $.widget('bijou.pickadate', $.bijou.base, {
    options: {
      dateFormat: 'en-GB'
    },

    dateformats: {
      'en-US': { 'default': 'mm/dd/yy', 'mobile': 'D, M d yy' },
      'en-GB': { 'default': 'dd/mm/yy', 'mobile': 'D, d M yy' }
    },

    _dateFormat: function () {
      return this.dateformats[this.options.dateFormat]['default']
    },

    _mobileDateFormat: function () {
      return this.dateformats[this.options.dateFormat]['mobile']
    },

    _create: function () {
      if (this.element.is(':input')) {
        this.dateInput = this.element
      } else {
        this.dateInput = this.element.find('input')
      }

      var minDate = this.dateInput.data('ruleMindate')
      var maxDate = this.dateInput.data('ruleMaxdate')

      this.breakpointEnabled()

      if (this.options.breakpoint === 'mobile') {
        if (minDate && maxDate) {
          this._replaceWithDropdown(minDate, maxDate)
        }
      } else {
        this._applyDatepicker(minDate, maxDate)
      }

      var today = new Date()
      var tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 1)

      this._on({
        'click .pickadate-today': function (e) {
          e.preventDefault()
          this.dateInput.val($.datepicker.formatDate(this._dateFormat(), today))
          this._triggerValidation()
          this.dateInput.trigger('change')
        },

        'click .pickadate-tomorrow': function (e) {
          e.preventDefault()
          this.dateInput.val($.datepicker.formatDate(this._dateFormat(), tomorrow))
          this._triggerValidation()
          this.dateInput.trigger('change')
        }
      })
    },

    _applyDatepicker: function (minDate, maxDate) {
      var input = this.dateInput
      var _this = this

      input.datepicker({
        dateFormat: this._dateFormat(),
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        firstDay: 1,
        showAnim: false,
        minDate: minDate && $.datepicker.parseDate(this._dateFormat(), minDate),
        maxDate: maxDate && $.datepicker.parseDate(this._dateFormat(), maxDate),
        onSelect: function () {
          input.trigger('change')
          _this._triggerValidation()
          input.focus()
          // Focus causes datepicker to open
          // so close it with a tiny delay
          setTimeout(function () {
            input.datepicker('hide')
          }, 1)
        }
      })

      input.attr('autocomplete', 'off')

      this._on(this.window, {
        resize: function () {
          input.datepicker('hide')
        }
      })

      this._on(input, {
        click: function () {
          input.datepicker('show')
        },
      })
    },

    _replaceWithDropdown: function (minDate, maxDate) {
      var input = this.dateInput

      var select = $('<select>').attr('id', input.attr('id'))
        .attr('name', input.attr('name'))
        .attr('data-date-format', input.attr('data-date-format'))
        .addClass(input.attr('class'))
        .removeClass('medium')
        .append('<option value="">Select a date</option>')

      var optionDate = $.datepicker.parseDate(this._dateFormat(), minDate)
      maxDate = $.datepicker.parseDate(this._dateFormat(), maxDate)

      while (optionDate.getTime() <= maxDate.getTime()) {
        select.append($('<option/>')
          .attr('value', $.datepicker.formatDate(this._dateFormat(), optionDate))
          .text($.datepicker.formatDate(this._mobileDateFormat(), optionDate)))
        optionDate.setDate(optionDate.getDate() + 1)
      }

      if (input.val()) {
        select.val(input.val())
      }

      input.replaceWith($('<div class="select-wrapper"/>').wrapInner(select))

      this.dateInput = select
    },

    _triggerValidation: function () {
      var validator = this.options.form.validate()
      if (validator.submitted[this.dateInput[0].name]) {
        this.dateInput.valid()
      }
    }

  })
}(window.jQuery))
